export default "__VITE_ASSET__N$VLV3$Y__"